import { createContext } from "react";

import { Authentication, defaultAuthentication } from "./authentication-model.context.lib";

export const AuthenticationContext = createContext<Authentication>(defaultAuthentication);
